import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Upload from '../../upload/Upload';
import actions from '@/redux/action';
import { request } from '@/api/request';
import moment from 'moment';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import AudioWorkHeaderFunction from './children/audioWorkHeaderFunction/AudioWorkHeaderFunction';
import AudioWorkContentFunction from './children/audioWorkContentFunction/AudioWorkContentFunction';
import AudioWorkFooterFunction from './children/audioWorkFooterFunction/AudioWorkFooterFunction';
import AudioWorkFinishFunction from './children/audioWorkFinishFunction/AudioWorkFinishFunction';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
import Process from '@/components/common/process/Process';
import '@/assets/audioCutSpeedVolume.less';

class AudioCutAndSpeedAndVolumeWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioAccept: '.wav,.mp3,.m4a,.aac,.ogg,.mp4,.mov,.webm',
      audioWorkStatus: '',
      audioJoinerAfter: {},
      submitting: false,
      pageWork: this.props.work || 'audioCut',
    };
    this.cancelWork = false;
  }

  getOutputLabel = (audioCutSpeedVolumeObj) => {
    if (!audioCutSpeedVolumeObj) {
      audioCutSpeedVolumeObj = { ...this.props.audioCutSpeedVolumeObj };
    }
    let size =
      Utils.getSeconds(audioCutSpeedVolumeObj.end) -
      Utils.getSeconds(audioCutSpeedVolumeObj.start);
    let volume = parseInt((audioCutSpeedVolumeObj.volume * 100 * 3).toFixed(0));
    let speed = audioCutSpeedVolumeObj.speed;
    return '1_' + size + 's_' + volume + '%_' + speed + 'x';
  };

  handleSubmit = async (format, isClickExport) => {
    if (
      Utils.getSeconds(this.props.audioCutSpeedVolumeObj.end) -
        Utils.getSeconds(this.props.audioCutSpeedVolumeObj.start) <
      0.1
    ) {
      return false;
    }
    if (isClickExport) {
      sentGAEvent({
        category: 'audio_all_output',
        action: 'audio_export_click',
        label:
          'click_' +
          (this.state.isAmbosChangeTime ? 'ambos_' : '') +
          (this.state.isTextBoxChangeTime ? 'textbox_' : '') +
          (this.state.isTrackChange ? 'track_' : '') +
          'from_' +
          (this.state.pageWork === 'audioCut'
            ? 'cut'
            : this.state.pageWork === 'audioVolume'
            ? 'volume'
            : 'speed'),
      });
    }
    sentGAEvent({
      category: 'audio_all_output',
      action: 'audio_export_all_content',
      label: this.getOutputLabel(),
    });
    this.cancelWork = false;
    this.setState({ format, submitting: true });
    const audioCutSpeedVolumeObj = { ...this.props.audioCutSpeedVolumeObj };
    if (!audioCutSpeedVolumeObj.uploadStatus) {
      this.props.onProcessStepChange(3);
    } else {
      this.props.onProcessStepChange(2);
    }
    if (!audioCutSpeedVolumeObj.uploadStatus) {
      let fileResponse;
      try {
        fileResponse = await this.requestUploadAudioFile(
          audioCutSpeedVolumeObj.fileObj
        );
        if (this.props.work === 'audioVolume') {
          sentGAEvent({
            category: 'UploadSuccess',
            action: '30ACV_UploadSuccess',
          });
        } else if (this.props.work === 'audioSpeed') {
          sentGAEvent({
            category: 'UploadSuccess',
            action: '31ACS_UploadSuccess',
          });
        } else if (this.props.work === 'audioCut') {
          sentGAEvent({
            category: 'UploadSuccess',
            action: '32AC_UploadSuccess',
          });
        }
      } catch (error) {
        if (error !== 'cancel') {
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label: error + '_none_none_' + this.props.tokenId + '_none_none',
          });
        }
        this.handleSubmitFail(error);
        return false;
      }
      if (this.cancelWork) {
        this.handleSubmitFail('cancel');
        return false;
      }
      if (fileResponse.code === 200) {
        if (fileResponse.data.result.number) {
          const fileResponseNumber = fileResponse.data.result.number;
          const fileResponseUrl = fileResponse.data.response_file[0];
          try {
            if (this.props.work === 'audioVolume') {
              sentGAEvent({
                category: 'ProcessStart',
                action: '30ACV_ProcessStart',
              });
            } else if (this.props.work === 'audioSpeed') {
              sentGAEvent({
                category: 'ProcessStart',
                action: '31ACS_ProcessStart',
              });
            } else if (this.props.work === 'audioCut') {
              sentGAEvent({
                category: 'ProcessStart',
                action: '32AC_ProcessStart',
              });
            }
            await Utils.getProgress(fileResponseNumber, false);
          } catch (error) {
            if (error !== 'cancel') {
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: 'uploadAudio' + '_200_200_' + error,
              });
            }
            this.handleSubmitFail(error);
            if (fileResponse.code === 401) {
              Cookies.remove('authorization', {
                domain: api_domain_config.DOMAIN,
              });
              let hostName = window.location.hostname;
              Cookies.remove('access_token', {
                domain: hostName.substring(
                  window.location.hostname.indexOf('.'),
                  hostName.length
                ),
              });
              Cookies.remove('access_token_expires_in', {
                domain: hostName.substring(
                  hostName.indexOf('.'),
                  hostName.length
                ),
              });
              window.location.replace(
                `${accountList.get('login')}?redirect=${window.location.href}`
              );
            }
            return false;
          }
          audioCutSpeedVolumeObj.videofileurl = fileResponseUrl;
          audioCutSpeedVolumeObj.status = 'uploaded';
          audioCutSpeedVolumeObj.uploadStatus = true;
          this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
        }
      } else {
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            'uploadAudio' +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
        this.handleSubmitFail();
        return false;
      }
    }

    if (this.cancelWork) {
      this.handleSubmitFail('cancel');
      return false;
    }
    let workResponse;
    try {
      workResponse = await this.requstAudioCutSpeedVolume(
        format,
        this.getRequestData(audioCutSpeedVolumeObj)
      );
    } catch (error) {
      if (error !== 'cancel') {
        sentGAEvent({
          category: 'audio_all_output',
          action: 'audio_export_all_failed',
          label: error + '_none_none_' + this.props.tokenId + '_none_none',
        });
        sentGAEvent({
          category: 'audio_all_output',
          action: 'audio_export_all_content',
          label: this.getOutputLabel() + '_failed',
        });
      }
      this.handleSubmitFail(error);
      return false;
    }
    if (this.cancelWork) {
      this.handleSubmitFail('cancel');
      return false;
    }
    if (workResponse.code === 200) {
      if (workResponse.data.result.number) {
        const workResponseNumber = workResponse.data.result.number;
        let progressResponse;
        try {
          progressResponse = await Utils.getProgress(workResponseNumber, false);
        } catch (error) {
          if (error !== 'cancel') {
            sentGAEvent({
              category: 'audio_all_output',
              action: 'audio_export_all_failed',
              label: 'cutAudio' + '_200_200_' + error,
            });
            sentGAEvent({
              category: 'audio_all_output',
              action: 'audio_export_all_content',
              label: this.getOutputLabel() + '_failed',
            });
          }
          this.handleSubmitFail(error);
          return false;
        }
        const audioJoinerAfter = {
          name: moment(new Date()).format('YYYYMMDDHHmmss') + '.' + format,
          size: parseFloat(progressResponse.info[0].size),
          downloadurl: progressResponse.info[0].url,
          duration: moment('00:00:00', 'mm:ss:SS')
            .add(
              parseFloat(parseFloat(progressResponse.info[0].duration)),
              'seconds'
            )
            .format('mm:ss:SS')
            .replace(/:([^:]*)$/, '.$1'),
        };
        this.setState({
          submitting: false,
          audioWorkStatus: 'success',
          audioJoinerAfter,
        });
        if (this.props.work === 'audioVolume') {
          sentGAEvent({
            category: 'ProcessSuccess',
            action: '30ACV_ProcessSuccess',
          });
        } else if (this.props.work === 'audioSpeed') {
          sentGAEvent({
            category: 'ProcessSuccess',
            action: '31ACS_ProcessSuccess',
          });
        } else if (this.props.work === 'audioCut') {
          sentGAEvent({
            category: 'ProcessSuccess',
            action: '32AC_ProcessSuccess',
          });
        }
        sentGAEvent({
          category: 'audio_all_output',
          action: 'audio_export_all_content',
          label: this.getOutputLabel(audioJoinerAfter) + '_success',
        });
        this.props.onProcessPercentChange(0);
        this.props.onProcessStepChange(0);
        this.props.onUploadPercentChange(0);
      }
    } else {
      if (workResponse.code === 402102) {
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
          trigger: '6TrialOver',
        });
        if (this.props.work === 'audioVolume') {
          sentGAEvent({
            category: 'UpgradePrompShow',
            action: '30ACV_UpgradePrompShow',
          });
        } else if (this.props.work === 'audioSpeed') {
          sentGAEvent({
            category: 'UpgradePrompShow',
            action: '31ACS_UpgradePrompShow',
          });
        } else if (this.props.work === 'audioCut') {
          sentGAEvent({
            category: 'UpgradePrompShow',
            action: '32AC_UpgradePrompShow',
          });
        }

        this.handleSubmitFail('cancel');
      } else {
        this.handleSubmitFail();
      }
      sentGAEvent({
        category: 'audio_all_output',
        action: 'audio_export_all_failed',
        label:
          'cutAudio_' +
          workResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          workResponse.msg,
      });
      sentGAEvent({
        category: 'audio_all_output',
        action: 'audio_export_all_content',
        label: this.getOutputLabel() + '_failed',
      });

      return false;
    }
  };

  handleSubmitFail = (error) => {
    if (error !== 'cancel') {
      this.setState({
        audioWorkStatus: 'failed',
      });
    }
    this.setState({ submitting: false });
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(0);
    this.props.onUploadPercentChange(0);
  };

  getRequestData = (audioCutSpeedVolumeObj) => {
    let data = {
      file_url: audioCutSpeedVolumeObj.videofileurl,
      from: '00:' + audioCutSpeedVolumeObj.start,
      to: '00:' + audioCutSpeedVolumeObj.end,
      mode: audioCutSpeedVolumeObj.cutOrTrim === 'cut' ? 'Extract' : 'Delete',
      fade_in: audioCutSpeedVolumeObj.fadeIn ? true : false,
      fade_out: audioCutSpeedVolumeObj.fadeOut ? true : false,
      volume: parseInt(audioCutSpeedVolumeObj.volume),
      speed: audioCutSpeedVolumeObj.speed,
    };
    console.log(data);
    return data;
  };

  requstAudioCutSpeedVolume = (format, data) => {
    const formData = new FormData();
    formData.append('output_format', format);
    formData.append('file_url', data.file_url);
    formData.append('from', data.from);
    formData.append('to', data.to);
    formData.append('mode', data.mode);
    formData.append('fade_in', data.fade_in);
    formData.append('fade_out', data.fade_out);
    formData.append('volume', data.volume);
    formData.append('speed', data.speed);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`cutAudio`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requestUploadAudioFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    console.log('this.props.work', this.props.work);
    if (this.props.work === 'audioVolume') {
      sentGAEvent({
        category: 'UploadStart',
        action: '30ACV_UploadStart',
      });
    } else if (this.props.work === 'audioSpeed') {
      sentGAEvent({
        category: 'UploadStart',
        action: '31ACS_UploadStart',
      });
    } else if (this.props.work === 'audioCut') {
      sentGAEvent({
        category: 'UploadStart',
        action: '32AC_UploadStart',
      });
    }

    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadAudio`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadAudio_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        console.log('ddddddddddd', JSON.parse(xhr.response));
        resolve(JSON.parse(xhr.response));
        console.log('xxxxxxx');
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  addFileCallBack = (audioCutSpeedVolumeObj) => {
    console.log('addFileCallBack', audioCutSpeedVolumeObj);
    audioCutSpeedVolumeObj.start = '00:00.00';
    audioCutSpeedVolumeObj.end = audioCutSpeedVolumeObj.duration;
    audioCutSpeedVolumeObj.cutOrTrim = 'cut';
    audioCutSpeedVolumeObj.speed = 1;
    audioCutSpeedVolumeObj.speedValue = [1, 1];
    audioCutSpeedVolumeObj.volume = 100;
    audioCutSpeedVolumeObj.volumeValue = [
      audioCutSpeedVolumeObj.volume,
      audioCutSpeedVolumeObj.volume,
    ];
    this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
  };

  handleAudioJoinerItemChange = (audioJoinerItem, relativeAudioObj) => {
    const audioJoinerList = [...this.props.audioJoinerList];
    for (let i = 0; i < audioJoinerList.length; i++) {
      if (audioJoinerList[i].guid === audioJoinerItem.guid) {
        if (i === 0 && audioJoinerList.length > 1) {
          audioJoinerList[i + 1].fadeIn = audioJoinerItem.fadeOut;
        }
        audioJoinerList[i] = { ...audioJoinerItem };
        break;
      }
    }
    if (relativeAudioObj) {
      audioJoinerList[relativeAudioObj.index] = {
        ...relativeAudioObj.audioJoinerItem,
      };
    }
    this.props.onAudioJoinerListChange(audioJoinerList);
  };

  cancelProcessCallBack = () => {
    this.setState({
      submitting: false,
    });
    this.cancelWork = true;
  };

  handleDeleteAudioObj = () => {
    const { pageWork } = this.state;
    sentGAEvent({
      category:
        pageWork === 'audioCut'
          ? 'audio_cut_action'
          : pageWork === 'audioVolume'
          ? 'audio_volume_action'
          : 'audio_speed_action',
      action:
        pageWork === 'audioCut'
          ? 'audio_cut_track_delete'
          : pageWork === 'audioVolume'
          ? 'audio_volume_track_delete'
          : 'audio_speed_track_delete',
    });
    this.props.onAudioCutSpeedVolumeObjChange(null);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.work !== this.props.work) {
      this.setState({
        pageWork: this.props.work,
      });
    }
  }

  render() {
    const { t, work, audioCutSpeedVolumeObj } = this.props;
    const isSmallerThanLimit = audioCutSpeedVolumeObj
      ? audioCutSpeedVolumeObj.cutOrTrim === 'cut'
        ? Utils.getSeconds(audioCutSpeedVolumeObj.end) -
            Utils.getSeconds(audioCutSpeedVolumeObj.start) <
          0.1
        : Utils.getSeconds(audioCutSpeedVolumeObj.start) +
            Utils.getSeconds(audioCutSpeedVolumeObj.duration) -
            Utils.getSeconds(audioCutSpeedVolumeObj.end) <
          0.1
      : false;
    return (
      <div className='audio-work-cont'>
        {this.state.audioWorkStatus !== 'failed' &&
        this.state.audioWorkStatus !== 'success' ? (
          <div>
            {!audioCutSpeedVolumeObj ? (
              <div>
                <h1 className='container'>
                  {work === 'audioCut'
                    ? t('HitPaw Online Audio Cutter')
                    : work === 'audioVolume'
                    ? t('HitPaw Online Volume Changer')
                    : t('HitPaw Online Audio Speed Changer')}
                </h1>
                <p className='container sub-title'>
                  {work === 'audioCut'
                    ? t('Trim or cut any audio files online.')
                    : work === 'audioVolume'
                    ? t('Turn up or Turn down the volume of audio.')
                    : t('Speed up or slow down audios online easily.')}
                </p>
                <Upload
                  visible={!audioCutSpeedVolumeObj}
                  accept={this.state.audioAccept}
                  isPreloadBlob
                  addFileByUrlVisible
                  addFileCallBack={this.addFileCallBack}
                />
              </div>
            ) : null}
            {audioCutSpeedVolumeObj && !this.state.submitting ? (
              <div className='workplace'>
                <AudioWorkHeaderFunction
                  pageWork={this.state.pageWork}
                  handelPageWorkChange={(pageWork) =>
                    this.setState({ pageWork })
                  }
                />
                <AudioWorkContentFunction
                  isSmallerThanLimit={isSmallerThanLimit}
                  pageWork={this.state.pageWork}
                  audioCutSpeedVolumeObj={audioCutSpeedVolumeObj}
                  onAudioCutSpeedVolumeObjChange={
                    this.props.onAudioCutSpeedVolumeObjChange
                  }
                  handleDeleteAudioObj={this.handleDeleteAudioObj}
                  handleTimeChangeType={(type) => {
                    switch (type) {
                      case 'track':
                        this.setState({ isTrackChange: true });
                        break;
                      case 'textbox':
                        this.setState({ isTextBoxChangeTime: true });
                        break;
                      case 'ambos':
                        this.setState({ isAmbosChangeTime: true });
                        break;
                      default:
                        break;
                    }
                  }}
                />
                <AudioWorkFooterFunction
                  isSmallerThanLimit={isSmallerThanLimit}
                  handleSubmit={this.handleSubmit}
                  work={this.props.work}
                />
              </div>
            ) : null}
            {this.state.submitting ? (
              <div
                className='workplace'
                style={{ position: 'relative', minHeight: 400 }}
              >
                <Process
                  visible
                  theme='dark'
                  showProcessText
                  processText='Processing'
                  hideCancelText
                  cancelProcessCallBack={this.cancelProcessCallBack}
                />
              </div>
            ) : null}
          </div>
        ) : null}
        {this.state.audioWorkStatus === 'failed' ||
        this.state.audioWorkStatus === 'success' ? (
          <AudioWorkFinishFunction
            work={this.props.work}
            status={this.state.audioWorkStatus}
            audioJoinerAfter={this.state.audioJoinerAfter}
            format={this.state.format}
            handleSubmitAgain={() => {
              this.setState(
                {
                  audioWorkStatus: 'ready',
                  submitting: true,
                },
                () => this.handleSubmit(this.state.format)
              );
            }}
          />
        ) : null}
      </div>
    );
  }
}
const mapStateToPropos = (state) => ({
  audioCutSpeedVolumeObj: state.work.audioCutSpeedVolumeObj,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  work: state.work.work,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onAudioCutSpeedVolumeObjChange: (audioCutSpeedVolumeObj) =>
    dispatch(actions.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onWorkChange: (work) => dispatch(actions.onWorkChange(work)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});
export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(
  withTranslation(['audioCutAndSpeedAndVolume'])(AudioCutAndSpeedAndVolumeWork)
);
